/** @jsxImportSource @emotion/react */
import { CardContainer } from "../../../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../../../components/page-skeleton/PageHeader";
import { ButtonInternalLink } from "../../../../components/NewButtons";
import { useGetAdyenAccountHolderBusinessLines } from "../../service/adyen-account-holders-api";
import { useParams } from "react-router";
import { Divider } from "../../../../components/Divider";
import { CardBody } from "../../../../components/page-skeleton/CardBody";
import { css } from "@emotion/react";
import { EmptyState } from "../../../../components/EmptyState";
import { PageFooter } from "../../../../components/page-skeleton/PageFooter";
import { StyledText } from "../../../../assets/typography/typography";
import { SpinnerBlock } from "../../../common/Spinner";
import { AdyenAccountHolderBusinessLinesTable } from "./AdyenAccountHolderBusinessLinesTable";
import { routes } from "../../../../appRoutingHelpers";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../auth/authSelectors";
const cardBodyAdditionalStyling = css`
  padding-bottom: 24px;
`;

export const AdyenAccountHolderBusinessLines = () => {
  const { id } = useParams();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const {
    data: businessLines,
    isLoading,
  } = useGetAdyenAccountHolderBusinessLines(id);

  if (isLoading || !businessLines) {
    return <SpinnerBlock />;
  }

  return (
    <CardContainer>
      <PageHeader
        title="Business lines"
        subtitle="Manage all of your Business lines for this account holder"
      >
        <ButtonInternalLink
          to={routes.adyenAccountHolderBusinessLinesNew(
            organizationKeyName,
            id
          )}
        >
          Create new business line
        </ButtonInternalLink>
      </PageHeader>
      {businessLines.length === 0 ? (
        <>
          <Divider />
          <CardBody additionalStyles={cardBodyAdditionalStyling}>
            <EmptyState
              title="No business lines created yet"
              subtitle="Click in the top right corner to create your first new business line."
            />
          </CardBody>
        </>
      ) : (
        <div>
          <AdyenAccountHolderBusinessLinesTable businessLines={businessLines} />
          <PageFooter>
            <StyledText className="bodyTextRegular mb-0">
              {businessLines.length}{" "}
              {businessLines.length === 1 ? "business line" : "business lines"}{" "}
              in total
            </StyledText>
          </PageFooter>
        </div>
      )}
    </CardContainer>
  );
};
